import { DASHBOARD_LABELS } from '@/constants/static/dashboardLabels';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="nova-footer" role="contentinfo">
      <div className="nova-footer-inner">
        <p className="nova-footer-brand">
          <span className="nova-logo-mark">{DASHBOARD_LABELS.app.logoMark}</span>
          <span>{DASHBOARD_LABELS.app.name}</span>
        </p>
        <p className="nova-footer-copyright">
          {DASHBOARD_LABELS.footer.copyright(year, DASHBOARD_LABELS.app.name)}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
